import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'tradapp.accountScope';
const EVENT_NAME = 'tradapp-account-scope-change';
const DEFAULT_SCOPE = { type: 'all', accountId: null, label: 'All accounts' };

export const accountIdForScope = (scope) => {
  if (scope?.type === 'demo') return 'demo';
  if (scope?.type === 'account' && scope.accountId != null && scope.accountId !== '') return String(scope.accountId);
  return 'all';
};

const readScope = () => {
  if (typeof window === 'undefined') return DEFAULT_SCOPE;
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
    if (!['all', 'demo', 'account'].includes(stored?.type)) return DEFAULT_SCOPE;
    if (stored.type === 'account' && (stored.accountId === null || stored.accountId === undefined || stored.accountId === '')) {
      return DEFAULT_SCOPE;
    }
    return { ...DEFAULT_SCOPE, ...stored };
  } catch {
    return DEFAULT_SCOPE;
  }
};

export default function useAccountScope() {
  const [scope, setScopeState] = useState(readScope);

  useEffect(() => {
    const sync = () => setScopeState(readScope());
    window.addEventListener('storage', sync);
    window.addEventListener(EVENT_NAME, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(EVENT_NAME, sync);
    };
  }, []);

  const setScope = useCallback((nextScope) => {
    const next = { ...DEFAULT_SCOPE, ...nextScope };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    setScopeState(next);
    window.dispatchEvent(new Event(EVENT_NAME));
  }, []);

  return { scope, setScope };
}
